// pages/sessions/SessionList.js
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../../services/api'

function SessionList() {
  const [sessions, setSessions] = useState([])

  useEffect(() => {
    loadSessions()
  }, [])

  const loadSessions = async () => {
    try {
      const res = await api.get('/session/company-sessions')
      setSessions(res.data.sessions)
    } catch (err) {
      console.log('❌ Error fetching sessions', err)
    }
  }

  return (
    <div>
      <h2>Company Sessions</h2>
      {sessions.map(s => (
        <div key={s.sessionId} style={{ border: '1px solid #ccc', margin: '5px', padding: '5px' }}>
          <p>Session ID: {s.sessionId}</p>
          <p>Active: {s.isActive ? 'Yes' : 'No'}</p>
          <p>Occupant: {s.occupant || 'none'}</p>
          <Link to={`/session/${s.sessionId}`}>Open Session</Link>
        </div>
      ))}
    </div>
  )
}

export default SessionList